// extracted by mini-css-extract-plugin
export default {"unrespondedMessageWrapper":"unrespondedMessageWrapper__MzE4Y","unrespondedMessage":"unrespondedMessage__MDY5Y","withBanner":"withBanner__YWE4Z"};